import { render } from "./addProduct.vue?vue&type=template&id=4c4ed480&scoped=true"
import script from "./addProduct.vue?vue&type=script&lang=js"
export * from "./addProduct.vue?vue&type=script&lang=js"

import "./addProduct.vue?vue&type=style&index=0&id=4c4ed480&scoped=true&lang=css"

import exportComponent from "C:\\file_data\\zxh\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4ed480"]])

export default __exports__